import { useNavigate } from "react-router-dom";
import { MdSearchOff } from "react-icons/md";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen bg-gray-50 text-center px-6">
      <div className="bg-gray-200 p-6 rounded-full mb-6">
        <MdSearchOff className="text-gray-500 text-6xl" />
      </div>
      <h1 className="text-6xl font-bold text-gray-700 mb-2">404</h1>
      <h2 className="text-2xl font-semibold text-gray-600 mb-3">
        Page Not Found
      </h2>
      <p className="text-gray-400 max-w-md mb-8">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div className="flex gap-3">
        <button
          onClick={() => navigate(-1)}
          className="px-5 py-2.5 rounded-lg border border-gray-400 text-gray-600 font-medium hover:bg-gray-100 transition-colors"
        >
          Go Back
        </button>
        <button
          onClick={() => navigate("/dashboard")}
          className="px-5 py-2.5 rounded-lg bg-primary text-white font-medium hover:bg-primary/90 transition-colors"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;
